export const tooltip_select_xps: string =
  "Seleciona arquivos XPS do computador local. O(s) arquivo(s) XPS deve ser do mesmo modelo do arquivo 'Exemplo'.";

export const tooltip_remover_xps: string =
  "Remove o arquivo XPS da análise ao lado.";

export const tooltip_toggle_log: string =
  "Se selecioando, os gráficos gerados serão em escala logarítmica.";

export const tooltip_execute: string = "Análisa os arquivos enviados.";

export const tooltip_download_example: string =
  "Exemplo de arquivo XPS utilizado por este software.";

export const tooltip_download_results: string = "Download dos resultados.";

export const tooltip_zeros_cut: string =
  "Número de zeros a serem ignorados. Recomenda-se o menor valor possível; muitos zeros influenciam na otimização dos paramêtros do modelo.";

export const tooltip_types_of_mean: string =
  "Tipo de média a ser utilizada nos cálculos. O manual do MasterSizer recomenda a utilização da média geométrica.";
